<ng-container *ngIf="isdataLoaded">
  <div class="container">
    <div class="content">
      <div class="center-column">
        <img class="nowaccount-logo" alt="NowAccount Logo" />
        <h1>{{ this.headerText }}</h1>
        <div class="button-wrapper">
          <app-primary-button [text]="this.emailText + '\n' + maskEmail(this.useremail)" href=""
            [clickEvent]="this.SendEmailCode.bind(this)">
          </app-primary-button>
        </div>
        <div class="button-wrapper" *ngIf="isPhoneNumberPresent">
          <app-primary-button [text]="
              this.phoneNumberText + '\n' + maskPhoneNumber(this.userPhone)
            " href="" [clickEvent]="this.SendPhoneCode.bind(this)">
          </app-primary-button>
        </div>
        <div class="button-wrapper" *ngIf="!isPhoneNumberPresent">
          <div class="Add-mobile">
            <app-stateful-internal-link [text]="this.inputTextAddPhoneNumber"
              [clickEvent]="this.AddPhoneNumber.bind(this)" [hasHover]="true"></app-stateful-internal-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>